import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssIconComponent } from '../icon/icon.component';
import { BadgeVariant } from '@umss/shared/utils';

@Component({
  selector: 'umss-badge',
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class UmssBadgeComponent {
  @HostBinding('style.display') display = 'contents';

  constructor() {}

  /** Content props - Clean and semantic */
  @Input() label: string = '';
  @Input() iconName?: string; // Phosphor icon name (e.g., 'phosphorCheck', 'phosphorX')

  /** Variant props - Well-typed and comprehensive (matching original badge) */
  @Input() variant: BadgeVariant = 'primary';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  /** Layout props - Simple and flexible */
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() removable: boolean = false;
  @Input() outlined: boolean = false;
  @Input() disabled: boolean = false;

  /** Events - Proper event handling */
  @Output() onRemove = new EventEmitter<MouseEvent>();

  /** Computed properties */
  get showLeftIcon(): boolean {
    return !!this.iconName && this.iconPosition === 'left';
  }

  get showRightIcon(): boolean {
    return !!this.iconName && this.iconPosition === 'right';
  }

  get iconSize(): string {
    switch (this.size) {
      case 'small':
        return '12px';

      case 'medium':
        return '14px';

      case 'large':
        return '16px';

      default:
        return '14px';
    }
  }

  onRemoveClick(event: MouseEvent) {
    if (!this.disabled) {
      this.onRemove.emit(event);
    }
  }
}
